// License validation removed.
// No external license check is required.
// Theme editor access will no longer be blocked.

(function () {
  const licenseErrorOverlay = document.getElementById('license-error-overlay');
  const licenseLoadingOverlay = document.getElementById('license-loading-overlay');
  const licenseCacheNotification = document.getElementById('license-cache-notification');

  if (licenseErrorOverlay) licenseErrorOverlay.remove();
  if (licenseLoadingOverlay) licenseLoadingOverlay.remove();
  if (licenseCacheNotification) licenseCacheNotification.remove();

  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
})();